import {createApp} from 'vue'
import Store from 'store'
import CartButton from './CartButton'

const el = '.nlx-component--cart-button'
const DOM = document.querySelector(el)

if(DOM){
    
    const cartButtonProps = {
        collisize : parseInt(DOM.dataset.collisize),
        productid : parseInt(DOM.dataset.productid),
        variantsku : parseInt(DOM.dataset.variantsku),
        isParentComponentBasket : !!(DOM.dataset.isParentComponentBasket)
    }
    
    const component = createApp(CartButton, {...cartButtonProps}).use(Store)
    
    component.mount(el)
}


